module.exports = {
      id: "logic-usage",
      viewBox: "0 0 19.765 19.765",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#logic",
      toString: function () {
        return this.url;
      }
    }